"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderLabelsDC3 = exports.LabelWrapper = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
function LabelWrapper(props) {
    var _a = useRenderLabelsDC3(props), certifications = _a.certifications, warnings = _a.warnings;
    switch (props.category) {
        case 'certification': return (certifications ? certifications : null);
        case 'warning': return (warnings ? warnings : null);
        default:
            (0, data_catalog_shared_1.assertUnreachable)(props.category);
            return null;
    }
}
exports.LabelWrapper = LabelWrapper;
function useRenderLabelsDC3(_a) {
    var _b, _c, _d, _e;
    var itemInfo = _a.itemInfo;
    var siteUrls = react_1.default.useContext(data_catalog_shared_1.SiteUrlsContext);
    var featureFlags = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext);
    var contentInfo = getContentInfo(itemInfo, siteUrls);
    var isColumn = itemInfo.__typename === 'Column';
    var isTable = itemInfo.__typename.includes('Table');
    var isEmbeddedDatasource = itemInfo.__typename === 'EmbeddedDatasource';
    var labelParams = {
        catalogEnabled: true,
        content: {
            contentId: itemInfo.id,
            contentLuid: (_b = contentInfo.contentLuid) !== null && _b !== void 0 ? _b : undefined,
            contentType: contentInfo.contentType,
            contentName: (_c = itemInfo.name) !== null && _c !== void 0 ? _c : undefined,
            contentUrl: (_d = contentInfo.contentUrl) !== null && _d !== void 0 ? _d : undefined,
            subjectArea: (_e = contentInfo.subjectArea) !== null && _e !== void 0 ? _e : undefined,
        },
        includeUpstream: !isColumn,
        includeParented: isTable,
        probablyOrEager: featureFlags.labelsInMorePlacesEnabled ? 'eager' : {},
        testId: contentInfo.testId,
        controls: {
            kind: isEmbeddedDatasource ? 'icon' : 'chip',
            siteUrls: siteUrls,
        },
        urls: siteUrls,
    };
    return (0, data_catalog_shared_1.useRenderLabels)(labelParams);
}
exports.useRenderLabelsDC3 = useRenderLabelsDC3;
function getContentInfo(labelContentItem, siteUrls) {
    switch (labelContentItem.__typename) {
        case 'DatabaseTable':
            return {
                contentLuid: labelContentItem.luid,
                contentType: 'table',
                contentUrl: siteUrls.catalogTableUrl(labelContentItem.id),
                subjectArea: labelContentItem.__typename,
                testId: 'TablePlacePageLabelsMasthead',
            };
        case 'Column': {
            var columnContentItem = labelContentItem;
            return {
                contentLuid: columnContentItem.luid,
                contentType: 'column',
                contentUrl: columnContentItem.table ? siteUrls.catalogTableColumnUrl(columnContentItem.table.id, columnContentItem.id) : null,
                subjectArea: null,
                testId: 'ColumnDetailsLabelDialog',
            };
        }
        case 'ColumnField':
        case 'DatasourceField':
        case 'CombinedField':
        case 'CalculatedField':
        case 'BinField':
        case 'HierarchyField':
        case 'CombinedSetField':
        case 'SetField':
        case 'Field':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: 'Field',
                testId: 'FieldDetailsLabelDialog',
            };
        case 'View':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: labelContentItem.__typename,
                testId: 'DataDetailsLabelsChip',
            };
        case 'EmbeddedDatasource':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: labelContentItem.__typename,
                testId: 'DataDetailsLabelsIcon',
            };
        case 'CloudFile':
        case 'File':
        case 'WebDataConnector':
        case 'DatabaseServer':
            return {
                contentLuid: labelContentItem.luid,
                contentType: 'database',
                contentUrl: siteUrls.catalogDatabaseUrl(labelContentItem.id),
                subjectArea: labelContentItem.__typename,
                testId: 'DatabasePlacePageLabelsMasthead',
            };
        default:
            (0, data_catalog_shared_1.assertUnreachable)(labelContentItem.__typename);
            throw new Error('Unreachable');
    }
}
//# sourceMappingURL=LabelsHookHelper.js.map